<template>
    <div class="ix-operations-form-item">
        <div>
            <span class="ix-drag-icon handle-line"></span>
        </div>
        <div class="ix-operations-form-item-content">
            <div class="form-group">
                <input type="text" class="form-control form-control-sm"  placeholder="Nom de l'opération" :name="'operations[' + index + '][designation]'" v-model="operation.designation" :id="'designation' + operation.uniq" required>
            </div>

            <div class="form-group">
                <select class="form-control form-control-sm" :name="'operations[' + index + '][state]'" :id="'state' + operation.uniq" v-model="operation.state" @change="emitEventOperationStateChanged">
                    <option :value="index" v-for="(state, index) in states" v-bind:key="index">{{ state }}</option>
                </select>
            </div>

            <div class="alert alert-warning" v-if="requiredStation == 1 && !operation.station_id">
                Le poste de travail est requis pour cette opération
            </div>

            <div v-show="is_expanded">
                <div class="form-group">
                    <label :for="'description' + operation.uniq">Informations complémentaires</label>
                    <textarea class="form-control form-control-sm" :name="'operations[' + index + '][description]'" :id="'description' + operation.uniq" rows="3" v-model="operation.description"></textarea>
                </div>

                <hr>
                <span class="ix-text-bold d-block mb-2">Contrôle qualité</span>

                <div class="form-group">
                    <label :for="'control_state' + operation.uniq">État</label>
                    <select class="form-control form-control-sm" :name="'operations[' + index + '][control_state]'" :id="'control_state' + operation.uniq" v-model="operation.control_state">
                        <option :value="index" v-for="(state, index) in controlStates" v-bind:key="index">{{ state }}</option>
                    </select>
                </div>

                <div class="form-group">
                    <label :for="'formAutocomplete' + operation.uniq" v-bind:class="{required: operation.is_control_required || operation.control_state == 2}">Formulaire</label>
                    <input type="text" class="form-control form-control-sm"  placeholder="Commencer la saisie pour obtenir des suggestions .." :name="'operations[' + index + '][form_designation]'" :id="'formAutocomplete' + operation.uniq" v-model="operation.form_designation" :required="operation.is_control_required == 1 || operation.control_state == 2">
                    <input type="hidden" :name="'operations[' + index + '][form_id]'" v-model="operation.form_id">
                    <input type="hidden" :name="'operations[' + index + '][id]'" v-model="operation.id">
                </div>

                <div class="form-group">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" value="1" class="custom-control-input" :name="'operations[' + index + '][is_control_required]'" :id="'isControlRequired' + operation.uniq" v-model="operation.is_control_required">
                        <label class="custom-control-label" :for="'isControlRequired' + operation.uniq">Contrôle qualité obligatoire avant étape suivante</label>
                    </div>
                </div>

                <hr>
                <span class="ix-text-bold d-block mb-2" v-bind:class="{required: requiredStation == 1}">Poste de travail</span>
                <select class="form-control" v-model="operation.station_id" :name="'operations[' + index + '][station_id]'" :required="requiredStation == 1">
                    <option :value="null">Ne pas affecter</option>
                    <option :value="station.id" v-for="(station, index) in stations" v-bind:key="index">{{ station.name }}</option>
                </select>
            </div>

            <div class="text-right mt-2">
                <button class="ix-btn link" @click="expandOperation" type="button">
                    <i class="far fa-chevron-up" v-if="is_expanded === true"></i>
                    <i class="far fa-chevron-down" v-if="is_expanded === false"></i>
                    {{ is_expanded ? 'Masquer' : 'Afficher' }} les détails
                </button>

                <button class="btn btn-sm danger transparent" @click="emitEventOperationDeleted" type="button">
                    <i class="far fa-trash"></i> Supprimer
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'

    export default {
        name: 'operation-form',
        props: ['operation', 'index', 'formsRoute', 'states', 'controlStates', 'stations', 'requiredStation'],
        data() {
            return {
                is_expanded: false
            };
        },
        methods : {
            expandOperation: function() {
                this.is_expanded = !this.is_expanded;
            },
            emitEventOperationStateChanged: function() {
                // Retirer commentaire pour chronologie stricte
                //this.$emit('operation-state-changed', this.index)
            },
            emitEventOperationDeleted: function () {
                this.$emit('operation-deleted', this.index)
            }
        },
        mounted() {
            if (!this.operation.designation && this.index > 0) {
                $('#designation' + this.operation.uniq).focus();
            }

            if (this.operation.form_id || this.operation.description) {
                this.expandOperation()
            }

            // Creation autocomplete
            $("#formAutocomplete" + this.operation.uniq).autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.formsRoute,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: {...{ q: request.term }},
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation,
                                })
                            }))
                        }
                    });
                },
                change: (e, item) => {
                    if(!item.item){
                        this.operation.form_id = null
                        this.operation.form_designation = null
                    }
                },
                select: (e, item) => {
                    this.operation.form_id = item.item.id
                    this.operation.form_designation = item.item.designation
                }
            }).focus(() => {
                $("#formAutocomplete" + this.operation.uniq).autocomplete("search", '');
            });
        }
    }
</script>
